export default __webpack_public_path__ + "static/media/caravanraidershideoutunchained.74e50a09.jpg";